import React, { useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { ROLE_LABELS, formatDate } from "@/lib/format";
import { PageHeader, Input } from "@/components/ui/kit";
import { DatePicker } from "@/components/DatePicker";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";

export default function Audit() {
  const [logs, setLogs] = useState([]);
  const [frm, setFrm] = useState("");
  const [to, setTo] = useState("");
  const [module, setModule] = useState("");

  const load = async () => {
    const params = {};
    if (frm) params.frm = frm;
    if (to) params.to = to;
    if (module) params.module = module;
    try { const { data } = await api.get("/audit", { params }); setLogs(data); } catch (e) { toast.error(apiErr(e)); }
  };
  useEffect(() => { load(); }, [frm, to, module]);

  return (
    <div>
      <PageHeader title="Auditoría" subtitle="Registro de todas las acciones del sistema">
        <select value={module} onChange={(e) => setModule(e.target.value)} data-testid="audit-module" className="h-10 px-3 rounded-lg bg-secondary border border-border focus:outline-none">
          <option value="">Todos los módulos</option>
          {["auth", "ventas", "pedidos", "inventario", "compras", "usuarios", "administracion"].map((m) => <option key={m} value={m}>{m}</option>)}
        </select>
        <DatePicker value={frm} onChange={setFrm} placeholder="Desde" testId="audit-from" />
        <DatePicker value={to} onChange={setTo} placeholder="Hasta" testId="audit-to" />
      </PageHeader>

      <div className="card-surface overflow-hidden">
        <table className="w-full text-sm" data-testid="audit-table">
          <thead className="bg-secondary/50 text-muted-foreground text-xs uppercase">
            <tr><th className="text-left p-3">Fecha</th><th className="text-left p-3">Usuario</th><th className="text-left p-3">Rol</th><th className="text-left p-3">Módulo</th><th className="text-left p-3">Acción</th><th className="text-left p-3">Detalle</th></tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} className="border-t border-border hover:bg-accent/30">
                <td className="p-3 text-muted-foreground whitespace-nowrap">{formatDate(l.timestamp)}</td>
                <td className="p-3 font-medium">{l.user_name}</td>
                <td className="p-3"><span className="text-xs text-primary">{ROLE_LABELS[l.user_role] || l.user_role}</span></td>
                <td className="p-3"><span className="text-xs px-2 py-0.5 rounded-full bg-secondary capitalize">{l.module}</span></td>
                <td className="p-3 capitalize">{l.action.replace(/_/g, " ")}</td>
                <td className="p-3 text-muted-foreground">{l.details}</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-muted-foreground"><ShieldCheck className="w-8 h-8 mx-auto mb-2 opacity-40" />Sin registros</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
